import axios from 'axios'

const state = {
  statusUpdate: null,
}

const getters = {
  getStatusUpdate(state) {
    return state.statusUpdate
  },
}

const mutations = {
  SET_SINGLE_STATUS_UPDATE(state, newValue) {
    state.statusUpdate = newValue
  },
}

const actions = {
  fetchStatusUpdate({ commit, dispatch, getters }, { statusUpdateId }) {
    return axios
      .get(`/api/v1/get_status_update/${statusUpdateId}`)
      .then((response) => {
        commit('SET_SINGLE_STATUS_UPDATE', response.data)
        return response.data
      })
  },
  postNewComment(
    { commit, dispatch, getters },
    { content, statusUpdateId, userId }
  ) {
    return axios
      .post(`/api/v1/comment`, {
        content: content,
        status: 'approved',
        status_update_id: statusUpdateId,
        user_id: userId,
      })
      .then((response) => {
        return response.data
      })
  },
  likeComment({ commit, dispatch, getters }, { commentId }) {
    return axios
      .post(`/api/v1/comments/add_like`, {
        commentId: commentId,
      })
      .then((response) => {
        return response.data
      })
  },
  likePost({ commit, dispatch, getters }, { statusUpdateId }) {
    return axios
      .post(`/api/v1/status_updates/add_like`, {
        statusUpdateId: statusUpdateId,
      })
      .then((response) => {
        return response.data
      })
  },
  changeStatus({ commit, dispatch, getters }, { statusUpdateId, status }) {
    return axios
      .post(`/api/v1/status_update/change_status`, {
        status: status,
        status_update_id: statusUpdateId,
      })
      .then((response) => {
        commit('SET_STATUS_UPDATE', response.data)
        return response.data
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
